module.exports = __webpack_public_path__ + "images/backgrounds/canyon/small.d23087dbf352e9a01e16.jpg";